import { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import HobbiesPeopleList from "../Components/HobbiesPeopleList";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import axios from "axios";
import "./SearchPeople.css";

function SearchPeople() {
  const [isLoading, setIsLoading] = useState(true);
  const [people, setPeople] = useState([]);
  const [hobby, setHobby] = useState("");
  const [hobbies, setHobbies] = useState([]);

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/hobbies/user/hobbies`,
        data: {
          language: state.language,
          userId: state.userId,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setHobbies(response.data.hobbies);
      setIsLoading(false);
    }
    fetch();
  }, [state.token, state.language, state.userId]);

  const handleSubmit = async () => {
    setIsLoading(true);
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/hobbies/search`,
      data: {
        organization: state.organization,
        hobby: hobby,
        userId: state.userId,
      },
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });

    setPeople(response.data.users);
    setIsLoading(false);
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col lg={12} className="values-header">
            <h2>{t("Hobbies.BuscarTitulo")}</h2>
          </Col>
        </Row>
        <Row>
          <Col className="inputContainer">
            <Row className="align-items-center">
              <Col lg={10}>
                <Form.Select
                  value={hobby}
                  onChange={(e) => setHobby(e.target.value)}
                >
                  <option>
                    {state.language === "es"
                      ? "Seleccionar Hobby"
                      : "Select Hobby"}
                  </option>
                  {hobbies.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.title}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col lg={2} className="center">
                <Button
                  className="primary-search primary"
                  onClick={handleSubmit}
                >
                  {t("Hobbies.Consultar")}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>

        {people.length > 0 ? (
          <Row>
            <HobbiesPeopleList people={people} language={state.language} />
          </Row>
        ) : (
          <></>
        )}
      </Container>
    );
  }
}

export default SearchPeople;
